import React from "react";
import ReactDOMServer from "react-dom/server";
import { EmptyNote, InfoTable, SectionTitle } from "./BnplFreezePDFUtils";

function baggageLabel(baggage) {
  if (!baggage) return "-";
  if (baggage.quantity != null) {
    return `${baggage.quantity} piece${baggage.quantity === 1 ? "" : "s"}`;
  }
  if (baggage.weight) return `${baggage.weight} ${baggage.unit || "kg"}`;
  return "-";
}

export default function BnplFreezePDFItineraryStatic({ flight }) {
  const flights = flight?.flights || [];
  const first = flights[0];

  const content = (
    <table className="w-full mb-2" cellPadding="0" cellSpacing="0">
      <tbody>
        <tr>
          <td>
            <SectionTitle>2. Travel Itinerary</SectionTitle>

            {flights.length ? (
              <table
                className="w-full mb-4 text-xs border border-gray-200"
                cellPadding="0"
                cellSpacing="0"
              >
                <thead>
                  <tr className="bg-gray-800 text-white">
                    <th className="px-2 py-2 text-left font-semibold">#</th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Flight
                    </th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Departure
                    </th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Arrival
                    </th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {flights.map((segment, index) => (
                    <tr
                      key={segment?._id || index}
                      className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-2 py-2 border-b border-gray-200 align-top font-bold text-gray-800">
                        {index + 1}
                      </td>
                      <td className="px-2 py-2 border-b border-gray-200 align-top">
                        <div className="font-bold text-gray-800">
                          {segment?.airline || "-"} {segment?.flightNumber || ""}
                        </div>
                        <div className="text-gray-500 mt-1">
                          {segment?.airlineName || ""}
                        </div>
                      </td>
                      <td className="px-2 py-2 border-b border-gray-200 align-top">
                        <div className="font-bold text-gray-800">
                          {segment?.departureLocationName ||
                            segment?.departureLocation}{" "}
                          ({segment?.departureLocation})
                        </div>
                        <div className="text-gray-500">
                          {segment?.departureAirport || "-"}
                        </div>
                        <div className="mt-1 text-gray-700">
                          {segment?.departureDate} · {segment?.departureTime}
                        </div>
                      </td>
                      <td className="px-2 py-2 border-b border-gray-200 align-top">
                        <div className="font-bold text-gray-800">
                          {segment?.arrivalLocationName ||
                            segment?.arrivalLocation}{" "}
                          ({segment?.arrivalLocation})
                        </div>
                        <div className="text-gray-500">
                          {segment?.arrivalAirport || "-"}
                        </div>
                        <div className="mt-1 text-gray-700">
                          {segment?.arrivalDate} · {segment?.arrivalTime}
                        </div>
                      </td>
                      <td className="px-2 py-2 border-b border-gray-200 align-top text-gray-700">
                        <div>Duration: {segment?.duration || "-"}</div>
                        <div>Stops: {segment?.stops ?? "-"}</div>
                        <div>Cabin: {segment?.cabinClass || "-"}</div>
                        <div>Class: {segment?.bookingClass || "-"}</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <EmptyNote>No itinerary available.</EmptyNote>
            )}

            <SectionTitle>3. Baggage</SectionTitle>
            <InfoTable
              rows={[
                {
                  label: "Carry-on",
                  value: baggageLabel(first?.carryOnBaggage),
                },
                {
                  label: "Checked baggage",
                  value: baggageLabel(first?.checkedBaggage),
                },
              ]}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
}
